import { useState } from 'react';
import Icon from '../../../components/AppIcon';

const SettingSection = ({ title, description, children, defaultExpanded = false }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="bg-card rounded-lg shadow-soft overflow-hidden mb-4">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-4 py-4 md:px-6 md:py-5 flex items-center justify-between hover:bg-muted/50 transition-all duration-250"
        aria-expanded={isExpanded}
        aria-label={`${isExpanded ? 'Collapse' : 'Expand'} ${title} section`}
      >
        <div className="flex-1 text-left">
          <h3 className="text-lg md:text-xl font-semibold text-foreground mb-1">
            {title}
          </h3>
          {description && (
            <p className="text-sm md:text-base text-muted-foreground">
              {description}
            </p>
          )}
        </div>
        <Icon
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'}
          size={20}
          color="var(--color-muted-foreground)"
          className="flex-shrink-0 ml-4 transition-transform duration-250"
        />
      </button>
      
      {isExpanded && (
        <div className="px-4 py-4 md:px-6 md:py-5 border-t border-border bg-card">
          {children}
        </div>
      )}
    </div>
  );
};

export default SettingSection;